import React from 'react'

import { useTranslation } from '../../../../../../../../app/_providers/TranslationProvider.client'

import { Container, Subtitle, TextWrap, Title } from './styles'

export const NoResultsTile: React.FC = () => {
  const {
    collections: {
      filtering: { noResults: strings },
    },
  } = useTranslation()

  return (
    <Container>
      <TextWrap>
        <Title>{strings.title}</Title>
        <Subtitle>{strings.subtitle}</Subtitle>
      </TextWrap>
    </Container>
  )
}
